import { largeHeaderImageHandler } from '../elements/LargeHeaderImage/LargeHeaderImage.handler';
import { smallHeaderImageHandler } from '../elements/SmallHeaderImage/SmallHeaderImage.handler';
import { textAreaHandler } from '../elements/TextArea/TextArea.handler';
import { simpleButtonHandler } from '../elements/SimpleButton/SimpleButton.handler';
import { emptySpaceHandler } from '../elements/EmptySpace/EmptySpace.handler';
import { calendarInvitationHandler } from '../elements/CalendarInvitation/CalendarInvitation.handler';
import { backgroundWithImageHandler } from '../elements/BackgroundImageWithText/BackgroundImageWithText.handler';

export const elementHandlers = {
    largeHeaderImageHandler,
    smallHeaderImageHandler,
    textAreaHandler,
    simpleButtonHandler,
    emptySpaceHandler,
    backgroundWithImageHandler,
    calendarInvitationHandler
}